import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl";
import { useParams, useNavigate } from "react-router-dom"; 
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";


const MyCustomForm = () => {
  const [fields, setFields] = useState([]);
  const [formData, setFormData] = useState({
    formName: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { exhibitionId, formId } = useParams();
  const navigate = useNavigate();
  
  const [visitorDetails, setVisitorDetails] = useState({
    name: "",
    email: "",
    phone: "",
    designation: "",
  });

  useEffect(() => {
    const fetchVisitorDetails = async () => {
      const visitorId = localStorage.getItem("visitor_id");
      if (!visitorId) {
        console.error("Visitor ID not found in localStorage.");
        return; // Stop if visitor ID is not found
      }
  
      try {
        const response = await axios.get(`${BASE_URL}fetchVisitorDetailsByUserId/${visitorId}`);
        if (response.data.success) {
          setVisitorDetails(response.data.visitor_details);
        } else {
          toast.error("Failed to fetch visitor details.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        console.error("Error fetching visitor details:", error);
        toast.error("An error occurred while fetching visitor details.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
  
    fetchVisitorDetails();
  }, []);
  
  useEffect(() => {
    const fetchFormDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}getCustomFormsById/${formId}`);
        
        const {
          form_name,
          pricingtype,
          amount,
          currency,
          paymentterms,
          cancellationterms,
          cancellationpolicy,
          cancellationprocess,
          evventozcancellationpolicy,
          fields
        } = response.data;
        
        // Store pricingtype and amount in separate variables
        const pricingType = pricingtype || 'free'; // Default value for pricingtype
        const amountValue = amount || '0'; // Default value for amount
  
        // Set the form data including all the necessary fields
        setFormData((prev) => ({
          ...prev,
          formName: form_name,
          pricingType: pricingType, // Use the stored pricingtype
          amount: amountValue, // Use the stored amount
          currency,
          paymentTerms: paymentterms,
          cancellationTerms: cancellationterms,
          cancellationPolicy: cancellationpolicy,
          cancellationProcess: cancellationprocess,
          evventozCancellationPolicy: evventozcancellationpolicy
        }));
  
        // Set fields as well
        setFields(fields); // Assuming fields are an array as per your response
  
      } catch (error) {
        console.error("Error fetching form:", error);
        toast.error("Failed to fetch form details.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
  
    fetchFormDetails();
  }, [formId]);
  
  

  // Handle change in field input (text, number, radio, checkbox, etc.)
  const handleFieldChange = (index, value) => {
    setFields((prevFields) => {
      const updatedFields = [...prevFields];
      updatedFields[index].value = value; // Store the value in the field object
      return updatedFields;
    });
  };

  // Save form data to the database
  const handleSubmitForm = async () => {
    let formIsValid = true;  // Declare formIsValid variable

    // Loop through each field and check if it's required
    fields.forEach((field) => {
      if (field.isrequired && !field.value) {
        toast.error(`${field.label} is required! Please fill out this field.`, {
          
        });
        formIsValid = false;  // Set to false if any required field is empty
      }
    });

    if (!formIsValid) {
      return; // Stop form submission if validation fails
    }

    const visitorId = localStorage.getItem("visitor_id");
    console.log("visitorId",visitorId);

    if (!visitorId) {
      console.error("Visitor ID not found in localStorage.");
      return; // Handle the absence of visitor ID as needed
  }


    console.log("Submitted data:", {
      fields, // This will show all the field values
      eventId: exhibitionId,
      formId: formId,
      formName: formData.formName, // Form name
      submitted_by: visitorId,
      submission_type: formData.pricingType,
      amount: formData.amount, 
    });

    setIsSubmitting(true); // Set submitting state
    

    try {
      const response = await axios.post(`${BASE_URL}submitformdata`, {
        fields, // Send the fields with values
        eventId: exhibitionId,
        formId: formId,
        formName: formData.formName,
        submitted_by: visitorId,
        submission_type: formData.pricingType,
      amount: formData.amount, 
      });

      console.log("rEsponse",response);

      if (response.status === 200) {
        // Navigate to the success page with response data
        // navigate("/check-status", { state: { submissionData: response.data } });
        navigate(-1);
      
        // Show SweetAlert2 success message (auto-closes after 2 seconds)
        Swal.fire({
          title: "Form Submitted Successfully!",
          icon: "success",
          timer: 3000, // Auto close after 2 seconds
          showConfirmButton: false,
        });
      }
       else {
        toast.error("Failed to save form.", {
           
        });
      }
    } catch (error) {
      console.error("Error saving form:", error);
      toast.error("An error occurred while saving the form.", {
     
      });
    } finally {
      setIsSubmitting(false); // Reset submitting state
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="mt-4">
        <div className="row">
          <div className="crd">
            <h4 className="hd-1 text-capitalize">{formData.formName}</h4>
            <hr />

 



            <div className="row p-3">
              <div className="col-md-12 border rounded">
                <div className="row g-3 p-3">
                <div className="col-md-4 text-start">
                    <label className="form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="formName"
                      className="input-class"
                      placeholder="Enter Name Here"
                      value={visitorDetails.name || ""}
                      onChange={(e) =>
                        setVisitorDetails((prev) => ({ ...prev, phone: e.target.value }))
                      }
                      required
                    />
                  </div>

                  <div className="col-md-4 text-start">
                    <label className="form-label">
                      Mobile No. <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="formName"
                      className="input-class"
                      placeholder="Enter Mobile No. Here"
                      value={visitorDetails.phone || ""}
  onChange={(e) =>
    setVisitorDetails((prev) => ({ ...prev, phone: e.target.value }))
  }
                      required
                    />
                  </div>

                  <div className="col-md-4 text-start">
                    <label className="form-label">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="formName"
                      className="input-class"
                      placeholder="Enter Email Here"
                      value={visitorDetails.email || ""}
  onChange={(e) =>
    setVisitorDetails((prev) => ({ ...prev, email: e.target.value }))
  }
                      required
                    />
                  </div>

                  <div className="col-md-4 text-start">
                    <label className="form-label">
                      Designation <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="formName"
                      className="input-class" 
                      placeholder="Enter Designation Here"
                      value={visitorDetails.designation || ""}
  onChange={(e) =>
    setVisitorDetails((prev) => ({ ...prev, designation: e.target.value }))
  }
                      required
                    />
                  </div>

                  {/* Display Added Fields */}
                  {fields.length > 0 ? (
                    fields.map((field, index) => (
                      <div key={index} className="col-md-4 text-start">
                        <label className="me-2">
                          {field.label}
                          {field.isrequired ? <span className="text-danger">*</span> : ""}
                        </label>

                        {/* Conditional rendering for different field types */}
                        {field.type === "text" && (
                          <input
                            type="text"
                            className="input-class" placeholder={`Enter ${field.label}`}
                            value={field.value || ""}
                            onChange={(e) => handleFieldChange(index, e.target.value)}
                            required={field.isrequired}
                          />
                        )}
                        {field.type === "number" && (
                          <input
                            type="number"
                            className="input-class"
                            value={field.value || ""}
                            onChange={(e) => handleFieldChange(index, e.target.value)}
                            required={field.isrequired}
                          />
                        )}
                        {field.type === "textarea" && (
                          <textarea
                            className="input-class"
                            value={field.value || ""}
                            rows="4"
                            onChange={(e) => handleFieldChange(index, e.target.value)}
                            required={field.isrequired}
                          ></textarea>
                        )}
                        {field.type === "radio" &&
                          JSON.parse(field.options).map((option, i) => (
                            <div key={i}>
                              <input
                                type="radio"
                                name={field.label}
                                value={option}
                                className="form-check-input"
                                checked={field.value === option}
                                onChange={(e) => handleFieldChange(index, e.target.value)}
                                required={field.isrequired}
                              />{" "}
                              {option}
                            </div>
                          ))}
                        {field.type === "checkbox" &&
                          JSON.parse(field.options).map((option, i) => (
                            <div key={i}>
                              <input
                                type="checkbox"
                                checked={field.value?.includes(option)}
                                onChange={(e) => {
                                  let newValue = [...(field.value || [])];
                                  if (e.target.checked) {
                                    newValue.push(option);
                                  } else {
                                    newValue = newValue.filter((opt) => opt !== option);
                                  }
                                  handleFieldChange(index, newValue);
                                }}
                                required={field.isrequired}
                              />{" "}
                              {option}
                            </div>
                          ))}
                        {field.type === "file" && (
                          <input
                            type="file"
                            className="input-class"
                            onChange={(e) => handleFieldChange(index, e.target.files)}
                            required={field.isrequired}
                          />
                        )}
                      </div>
                    ))
                  ) : (
                    <p>No fields added yet.</p>
                  )}




<div className="row mb-3 text-start">
  <div className="p-3">
  {formData.amount > 0 && (
  <div className="mb-3">
    <h1 className="text-end">
      <strong className="boot3">Ticket Cost : INR. {formData.amount}</strong>
    </h1>
  </div>
)}



{formData.paymentTerms && (
      <div className="mb-3">
        <h1 className="boot1"><strong>1. Payment Terms</strong></h1>
        <div className="boot2">{formData.paymentTerms}</div>
      </div>
    )}

    {formData.cancellationTerms && (
      <div className="mb-3">
        <h1 className="boot1"><strong>2. Cancellation Terms</strong></h1>
        <div className="boot2">{formData.cancellationTerms}</div>
      </div>
    )}

    {formData.cancellationPolicy && (
      <div className="mb-3">
        <h1 className="boot1"><strong>3. Cancellation Policy</strong></h1>
        <div className="boot2">{formData.cancellationPolicy}</div>
      </div>
    )}

    {formData.cancellationProcess && (
      <div className="mb-3">
        <h1 className="boot1"><strong>4. Cancellation Process</strong></h1>
        <div className="boot2">{formData.cancellationProcess}</div>
      </div>
    )}

 

  </div>
</div>





                  {fields.length > 0 && (
                    <div className="mt-3 text-end mb-3">
                      <Button
                        variant="success"
                        className="btnsubmit"
                        onClick={handleSubmitForm}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? <Spinner animation="border" size="sm" /> : "Submit"}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Toast container */}
      <ToastContainer />
    </div>
  );
};

export default MyCustomForm;
